import { PropTypes } from 'prop-types';

import Box from '@mui/material/Box';

import QuickActionsCard from './components/QuickActionsCard';
import Section from './components/Section';

import { PRODUCT_STATUS, WEBSITE_PRODUCTS } from './utils/constants';

const QuickActions = ({ entitlements, showWebsiteAction = false }) => {
  // Filter and format the orders for the quick action buttons
  const quickActions = Object.values(WEBSITE_PRODUCTS)
    .filter((p) => p !== WEBSITE_PRODUCTS.DOMAIN_PRIVACY)
    .reduce((res, product) => {
      const entitlement = entitlements.get(product);
      return entitlement ? [...res, entitlement?.fulfillment] : res;
    }, []);

  // Add website card if user has a website through TBUB offer.
  if (!entitlements.has(WEBSITE_PRODUCTS.WEBSITE) && showWebsiteAction) {
    quickActions.push({ orderTaskType: WEBSITE_PRODUCTS.WEBSITE });
  }

  return (
    <Section title="Shortcuts">
      <Box
        sx={{
          marginTop: 2,
          display: 'grid',
          gridTemplateColumns: {
            xs: '1fr 1fr 1fr',
            md: quickActions.length > 1 ? `repeat(${quickActions.length}, 1fr)` : null
          },
          gap: 1.5
        }}
      >
        {quickActions.map((action) => (
          <QuickActionsCard
            key={action.orderTaskType}
            type={action.orderTaskType}
            showLockIcon={
              action.orderTaskType === WEBSITE_PRODUCTS.EMAIL
              && action.derivedStatus === PRODUCT_STATUS.PENDING
            }
            {...(action.orderTaskType === WEBSITE_PRODUCTS.EMAIL && {
              CardProps: {
                target: '_blank'
              }
            })}
          />
        ))}
      </Box>
    </Section>
  );
};

QuickActions.propTypes = {
  entitlements: PropTypes.shape({
    has: PropTypes.func.isRequired,
    get: PropTypes.func.isRequired
  }).isRequired,
  showWebsiteAction: PropTypes.bool
};

export default QuickActions;
